// import ApplicationLogo from '@/Components/ApplicationLogo';
// import { Link } from '@inertiajs/react';
import loginBG from "@/assets/images/login_bg.png";
import "@/assets/css/index.scss";
import ApplocumBlueLogoIcon from "@/Components/Icons/ApplocumBlueLogoIcon";

import { Toaster } from "react-hot-toast";

/**
 * A component for handling main login functionality.
 *
 * @param {Object} children - The children components to be rendered inside MainLogin.
 * @param {string} csrf_token - The CSRF token for authentication.
 * @return {JSX.Element} The main login component.
 */

import React, { useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";

import { loadState } from "../localStorage";

import { useDispatch } from "react-redux";

import EmailRedirectRouting from "../Pages/EmailRedirectRouting";
import {
  setAllPermissions,
  setIsAuthenticated,
  setSession,
} from "../reducers/session";
import useTitle from "../utilities/hooks/useTitle";

const MainLogin = ({ children }) => {
  useTitle("AppLocum Agency");
  const savedState = loadState();
  const initialState = savedState;
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    if (initialState && initialState.session) {
      if (initialState.session && initialState.session.isAuthenticated) {
        dispatch(setIsAuthenticated(true));
      }
      dispatch(setAllPermissions(initialState.session.session.allPermissions));
      dispatch(setSession(initialState.session.session));
    }
  }, []);
  return (
    <div className="MainLogin_Wrapper relative min-h-screen bg-lightblue p-[40px]">
      <EmailRedirectRouting />

      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
        }}
      />
      <img
        src={loginBG}
        alt=""
        className="fixed right-0 top-1 z-[-2px] h-[calc(100%-8px)] max-h-screen translate-x-[45%] bg-left object-scale-down"
      />
      <div className="relative flex flex-col gap-[50px] xl:gap-[78px]">
        <ApplocumBlueLogoIcon />
        <div className="relative z-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLogin;
